import { topicsData } from '@/mocks/home';

const trendIcons: Record<string, string> = {
  hot: 'ri-fire-line text-red-500',
  rising: 'ri-arrow-up-line text-accent-500',
  stable: 'ri-subtract-line text-foreground-400',
  new: 'ri-sparkling-line text-primary-500',
};

const trendLabels: Record<string, string> = {
  hot: '热门',
  rising: '上升',
  stable: '稳定',
  new: '新晋',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-accent-700 bg-accent-50 px-3 py-1 rounded-full mb-3">
            热门话题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            大家都在讨论什么
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            热门电视剧话题标签，看看当下追剧圈最火的话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className="group flex items-center gap-3 bg-background-50 border border-background-200/60 rounded-full px-4 py-2.5 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <i className={`text-sm flex-shrink-0 ${trendIcons[topic.trend] || 'ri-hashtag text-foreground-400'}`}></i>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                {topic.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {topic.heat}
              </span>
              <span className={`text-xs px-1.5 py-0.5 rounded-full whitespace-nowrap ${
                topic.trend === 'hot' ? 'bg-red-50 text-red-600' :
                topic.trend === 'rising' ? 'bg-accent-50 text-accent-700' :
                topic.trend === 'new' ? 'bg-primary-50 text-primary-600' :
                'bg-background-200 text-foreground-500'
              }`}>
                {trendLabels[topic.trend]}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}